import index from '../views/index.vue'
import us from '../views/us.vue'
import news from '../views/news.vue'
import certificate from '../views/certificate.vue'
import responsibility from '../views/responsibility.vue'
import feature from '../views/feature.vue'
import featureEdu from '../views/feature_edu.vue'
import wechat from '../views/wechat.vue'
import participation from '../views/participation.vue'
import lesson from '../views/lesson.vue'
import earnings from '../views/earnings.vue'
import questions from '../views/questions.vue'
import drillExam from '../views/drillExam.vue'
import privacy from '../views/privacy'
import team from '../views/team'
import contact from '../views/contact'
import timeline from '../views/timeline'
import featureProduct from '../views/feature_product'
import featureFin from '../views/feature_fin'
import edu from '../views/solution/edu'
import enterprise from '../views/solution/enterprise'
import financial from '../views/solution/financial'
import medical from '../views/solution/medical'

const routers = [
  {
    path: '/',
    component: index,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件'
    }
  },
  {
    path: '/us',
    component: us,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_关于我们'
    }
  },
  {
    path: '/news',
    component: news,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_新闻资讯'
    }
  },
  {
    path: '/certificate',
    component: certificate,
    meta: {
      title: '爱拼考_云原生数字化教育系统_ 在线考试系统_考试软件_资质证书'
    }
  },
  {
    path: '/responsibility',
    component: responsibility,
    meta: {
      title: '爱拼考_云原生数字化教育系统_ 在线考试系统_考试软件_社会责任'
    }
  },
  {
    path: '/feature',
    component: feature,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_企业解决方案'
    }
  },
  {
    path: '/feature_edu',
    component: featureEdu,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_教育解决方案'
    }
  },
  {
    path: '/feature_product',
    component: featureProduct,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_生产企业解决方案'
    }
  },
  {
    path: '/feature_fin',
    component: featureFin,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_金融行业解决方案'
    }
  },
  {
    path: '/wechat',
    component: wechat,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_微信小程序端'
    }
  },
  {
    path: '/participation',
    component: participation,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_互动参与'
    }
  },
  {
    path: '/lesson',
    component: lesson,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_在线课程学习'
    }
  },
  {
    path: '/earnings',
    component: earnings,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_内容变现计划'
    }
  },
  {
    path: '/questions',
    component: questions,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_问卷调查'
    }
  },
  {
    path: '/drillExam',
    component: drillExam,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_在线练习考试'
    }
  },
  {
    path: '/privacy',
    component: privacy,
    meta: {
      title: '爱拼考_云原生数字化教育系统_ 在线考试系统_考试软件_隐私声明'
    }
  },
  {
    path: '/team',
    component: team,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_核心团队'
    }
  },
  {
    path: '/contact',
    component: contact,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_联系我们'
    }
  },
  {
    path: '/timeline',
    component: timeline,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_发展历程'
    }
  },
  {
    path: '/solution/edu',
    component: edu,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_教育机构'
    }
  },
  {
    path: '/solution/enterprise',
    component: enterprise,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_企业培训'
    }
  },
  {
    path: '/solution/medical',
    component: medical,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_医疗机构'
    }
  },
  {
    path: '/solution/financial',
    component: financial,
    meta: {
      title: '爱拼考_云原生数字化教育系统_在线考试系统_考试软件_金融行业'
    }
  }
]
export default routers